'use strict';

var _ = require('lodash');
var FaresOptimizerApproveModalDirective = function FaresOptimizerApproveModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-approve-modal.html'),
    controller: 'FaresOptimizerApproveModalController',
    scope: {
      approveCallback: '=',
      showApproveModal: '=',
      approveModalData: '='
    },
    link: function link($scope, $element) {
      $scope.$watch('showApproveModal', function (newVal) {
        if (newVal) {
          $scope.affectedLadderIdCount = $scope.approveModalData.affectedLadderIdCount;
          if ($scope.approveModalData.authorizationNotes !== undefined) {
            $scope.notes = $scope.approveModalData.authorizationNotes;
          }
          if ($scope.approveModalData.effectiveDate !== undefined) {
            $scope.uiDateRangeFrom = $scope.approveModalData.effectiveDate;
          }
          if ($scope.approveModalData.ladderDetails.length >= 1) {
            $scope.fareRecommendationRecordKeyList = _.chain($scope.approveModalData.ladderDetails).map('ladderId').value();
          }
          $scope.shouldDisplaySharedFbcMessage = $scope.approveModalData.hasSharedFbc;
          $scope.ladderDetails = $scope.approveModalData.ladderDetails;
          $element.modal('show');
          $scope.showApproveModal = false;
        }
      });
    }
  };
};
FaresOptimizerApproveModalDirective.$inject = [];
module.exports = FaresOptimizerApproveModalDirective;